import { IHttpService, IPromise, IQService } from 'angular';
import { GmcApi } from '../../constants/gmc-api';
import { IJobPositionCategory } from './job-positions.interfaces';
import { cloneDeep, sortBy } from 'lodash-es';
import { IDataMap } from '../../interfaces/data-map.interface';

export interface IFilterPositionsResponse {
  positions: IJobPositionCategory[];
}

export interface IPositionCategory {
  name: string;
  _id: string;
}

export interface IPosition {
  name: string;
  _id: string;
  categoryId: string;
}

export interface ICategoryWithPositions {
  _id: string;
  name: string;
  positions: IPosition[];
}

export class JobPositionService {
  static $inject = [
    '$http',
    '$q',
    'GmcApi'
  ];
  private categories: IPositionCategory[] = [];
  private positions: IPosition[] = [];
  private categoriesMap: IDataMap<IPositionCategory> = {};
  private positionsMap: IDataMap<IPosition> = {};
  private subpositions: any[] = [];
  private subpositionsMap: IDataMap<any> = {};

  private OLD_positions: IJobPositionCategory[];

  constructor( private $http: IHttpService,
               private $q: IQService,
               private gmcApi: GmcApi ) {
  }

  fetchAllPositions(): IPromise<any> {
    return this.$http.get<IFilterPositionsResponse>(this.gmcApi.helpers.getPositions)
      .then(( res ) => {
        this.transformResponse(res.data.positions);
        this.categoriesMap = this.buildCategoriesMap(this.categories);
        this.positionsMap = this.buildPositionsMap(this.positions);
      });
  }

  getPositions111( force?: boolean ): IPromise<IJobPositionCategory[]> {
    if ( force || !this.OLD_positions ) {
      return this.$http.get<IFilterPositionsResponse>(this.gmcApi.helpers.getPositions, { cache: true })
        .then(( res ) => {
          this.OLD_positions = sortBy(res.data.positions, [ 'name' ]);
          return this.OLD_positions;
        });
    }
    return this.$q.resolve(this.OLD_positions);
  }

  getCategories(): IPositionCategory[] {
    return cloneDeep(this.categories);
  }

  getPositions(): IPosition[] {
    return cloneDeep(this.positions);
  }

  getCategoriesMap(): IDataMap<IPositionCategory> {
    return this.categoriesMap;
  }

  getPositionsMap(): IDataMap<IPosition> {
    return this.positionsMap;
  }

  buildPositionsMapByCategory( positions: IPosition[] = [] ): IDataMap<IPosition[]> {
    const positionsByCategory: IDataMap<IPosition[]> = {};
    for ( const position of positions ) {
      const categoryId = position.categoryId;
      positionsByCategory[ categoryId ] = positionsByCategory[ categoryId ] || [];
      positionsByCategory[ categoryId ].push(position);
    }
    return positionsByCategory;
  }

  groupPositionsByCategoryArray( positions: IPosition[], categoriesMap: IDataMap<IPositionCategory> ): ICategoryWithPositions[] {
    const positionsMapByCategory = this.buildPositionsMapByCategory(positions);
    // console.log("positionsMapByCategory - ", positionsMapByCategory);
    let result: ICategoryWithPositions[] = [];
    Object.entries(positionsMapByCategory).forEach(( [ categoryId, categoryPositions ] ) => {
      const categoryName = categoriesMap[ categoryId ] ? categoriesMap[ categoryId ].name : '';
      const item: ICategoryWithPositions = {
        _id: categoryId,
        name: categoryName,
        positions: categoryPositions
      };
      if (item.name === 'Marine/ROV/Diving Jobs') {
        console.log(item.name);
        result = [item, ...result];
      } else {
        result.push(item);
      }
    });
    return result;
  }

  countPositionsByCategory( positions: IPosition[] ): IDataMap<number> {
    const positionsByCategoryCounters: IDataMap<number> = {};
    for ( const position of positions ) {
      const categoryId = position.categoryId;
      positionsByCategoryCounters[ categoryId ] = positionsByCategoryCounters[ categoryId ] || 0;
      positionsByCategoryCounters[ categoryId ] += 1;
    }
    return positionsByCategoryCounters;
  }

  filterPositionsByCategories( positions: IPosition[], categories: string[] ): IPosition[] {
    return positions.filter(( position ) => categories.includes(position.categoryId));
  }

  findCategoryById( categoryId: string ): IPositionCategory {
    for ( const category of this.categories ) {
      if ( category._id === categoryId ) {
        return cloneDeep(category);
      }
    }
    return null;
  }

  findPositionById( positionId: string ): IPosition {
    for ( const position of this.positions ) {
      if ( position._id === positionId ) {
        return cloneDeep(position);
      }
    }
    return null;
  }

  findPositionsByCategoryId( positions: IPosition[], categoryId: string ): IPosition[] {
    return positions.filter(( position ) => position.categoryId === categoryId);
  }

  searchPositionsByTerm( positions: IPosition[], term: string = '' ): IPosition[] {
    if ( term.length > 0 ) {
      return positions.filter(( position ) => {
        return position.name.toLowerCase().includes(term.toLowerCase());
      });
    }
    return positions;
  }

  private transformResponse( data: IJobPositionCategory[] ) {
    this.categories = [];
    this.positions = [];
    this.subpositions = [];
    for ( const category of data ) {
      const formattedCategory = {
        name: category.name,
        _id: category._id
      };
      this.categories.push(formattedCategory);
      for ( const position of category.categories ) {
        const formattedPosition = {
          _id: position._id,
          name: position.name,
          categoryId: category._id
        };
        this.positions.push(formattedPosition);
      }
    }
    this.categories = sortBy(this.categories, [ 'name' ]);
  }

  private buildCategoriesMap( categories: IPositionCategory[] = [] ): IDataMap<IPositionCategory> {
    const categoriesMap: IDataMap<IPositionCategory> = {};
    for ( const category of categories ) {
      categoriesMap[ category._id ] = category;
    }
    return categoriesMap;
  }

  private buildPositionsMap( positions: IPosition[] = [] ): IDataMap<IPosition> {
    const positionsMap: IDataMap<IPosition> = {};
    for ( const position of positions ) {
      positionsMap[ position._id ] = position;
    }
    return positionsMap;
  }
}



// WEBPACK FOOTER //
// ./app/core/services/job-position/job-position.service.ts